import {Observable} from "rxjs";
import {DirectTesting, DirectTestingDTO, DirectTestingQuery} from "../models/DirectTesting";
import {ItemList} from "../../../common/models/ItemList";
import {Container, IInit} from "../../../common/container/Container";
import {Query} from "../../../common/api/Query";
import {DirectTestingApi} from "../api/directTestingApi";
import {IStatusService} from "../../../common/status/StatusService";
import {STATUS_SERVICE_KEY} from "../../../container/app";


type Props = {
    apiKey: symbol
}

export interface DirectTestingService extends IInit {
    getByID(id: string): Observable<ItemList<DirectTesting>>
    getByMutationID(id: string): Observable<ItemList<DirectTesting>>
    getByIndividualID(id: string): Observable<ItemList<DirectTesting>>
    add(e: DirectTestingDTO): Observable<DirectTesting | undefined>
    update(e: DirectTestingDTO): Observable<DirectTesting | undefined>

   
    
}

export class DirectTestingService implements DirectTestingService {
    private readonly _apiKey: symbol
    private _container!: Container
    private _api!: DirectTestingApi
    private _statusService!: IStatusService

    constructor(p: Props) {
        this._apiKey = p.apiKey
    }

    init(c: Container) {
        this._container = c
        this._api = this._container.get<DirectTestingApi>(this._apiKey)
        this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
    }

    getByID(id: string): Observable<ItemList<DirectTesting>> {
        return this._api.getByID(id)
    }

    getByMutationID(id: string): Observable<ItemList<DirectTesting>> {
        return this._api.getByMutationID(id)
    }

    getByIndividualID(id: string): Observable<ItemList<DirectTesting>> {
        return this._api.getByIndividualID(id)
    }


    add(e: DirectTestingDTO): Observable<DirectTesting | undefined> {
        return this._api.add(e)
    }

    update(e: DirectTestingDTO): Observable<DirectTesting | undefined> {
        return this._api.update(e)
    }
}